module.exports = __webpack_public_path__ + "static/media/memory.239540b6.png";